import React, { useState } from "react";
import { Link } from "react-router-dom";
import '../style/blog.css'

const POSTS = [
  { id: 1, title: "Manual Testing Complete Guide", category: "Manual", description: "Learn fundamentals of manual testing with examples.", link:"/manual-testing" },
  { id: 2, title: "Automation Tester vs Manual Tester", category: "Career", description: "Understand the difference and career path.", link:"/manual-vs-automation-testing" },
  { id: 3, title: "Top 100 API Testing Interview Questions", category: "Interviews", description: "Most asked interview questions for testers.", link:"/api-testing-interview" },
  { id: 4, title: "Selenium Automation Basics", category: "Automation", description: "Start automation testing with Selenium.", link: "https://www.selenium.dev/documentation/webdriver/" }
];

function Blog() {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeCategory, setActiveCategory] = useState("All");

  const filteredPosts = POSTS.filter(post => {
    const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = activeCategory === "All" || post.category === activeCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <div className="blog-container">
      <h1>📝 Testing Resources</h1>
      
      {/* Advanced Features: Search and Filter */}
      <div id="blog-search" className="blog-controls">
        <input 
          type="text" 
          placeholder="Search articles..." 
          onChange={(e) => setSearchTerm(e.target.value)} 
        />
        <select onChange={(e) => setActiveCategory(e.target.value)}>
          <option value="All">All Categories</option>
          <option value="Manual">Manual</option>
          <option value="Automation">Automation</option>
          <option value="Interviews">Interviews</option>
        </select>
      </div>

      <div id="latest-articles" className="blog-grid">
        {filteredPosts.map((post) => (
          <div key={post.id} className="blog-card">
            <span className="category-badge">{post.category}</span>
           <h3>{post.title}</h3>
            <p>{post.description}</p>
            {post.link.startsWith("http") ? (
  <a href={post.link} target="_blank" rel="noopener noreferrer">
    Read Article →
  </a>
) : (
  <Link to={post.link}>Read Article →</Link>
)}
          </div>
        ))}
      </div>


     


    </div>
  );
}

export default Blog;
